import { DisplayObject } from 'pixi.js'
import resizer, { ResizerDimensions } from '../resizer'
import LayersContainer from '../Layer/LayersContainer'
import { positions, isArchive } from '../../config/settings'
import input from '../input'
import { events } from '../../config/events'
import buttons from '../../ui/buttons'
import { initApp, setApp, registerPlugins, isLowEnd, parkScene, resumeScene, getApp } from './sceneManager'
import { onResize } from './stagePositioning'
import { showBullets } from './sceneHelpers'
import { setupItemInteractions } from './itemInteractions'
import { SceneState } from './types'
import { createFrameOverlay } from './frameOverlay'

export { parkScene, resumeScene }

export default function createScene(): void {
  const state: SceneState = {
    items: [],
    sortedItems: [],
    touchedItem: undefined,
    itemOverDelayedCall: undefined,
    phase2HideTimer: undefined,
    isDragging: false,
    moveCounter: 0,
  }

  const app = initApp()
  setApp(app)
  initResizer(state)
  initLayersContainer(state)
  initFrameOverlay()
  // attachButtonListeners(state)
  enableInteractivity(state)
  registerPlugins()

  if (app) input.init(app, positions.initialRatio)

  function initResizer(state: SceneState) {
    const canvasContainer = document.querySelector<HTMLDivElement>('.canvas-container')!
    resizer.init(canvasContainer)
    
    // Listen for resize events and update canvas dimensions
    resizer.on(events.RESIZE, (dims: ResizerDimensions) => {
      onResize(dims, state.items, state.touchedItem, () => {})
    })
    
    // Initial resize with current dimensions
    const initialDims = resizer.getDimensions()
    if (initialDims) {
      onResize(initialDims, state.items, state.touchedItem, () => {})
    }
  }

  function initLayersContainer(state: SceneState) {
    const layersContainer = new LayersContainer(isLowEnd())
    const app = getApp()
    app?.stage.addChild(layersContainer as DisplayObject)
    layersContainer.startParallax()
    state.items = layersContainer.items
    state.sortedItems = [...state.items].sort((a, b) => a.activity.day - b.activity.day)
  }

  function initFrameOverlay(): void {
    const app = getApp()
    if (!app) return
    const frameOverlay = createFrameOverlay()
    app.stage.addChild(frameOverlay as DisplayObject)
  }

  function attachButtonListeners(state: SceneState) {
    buttons.on(events.HELP_BUTTON_CLICK, (active: boolean) => {
      showBullets(state.items, active)
    })
  }

  function enableInteractivity(state: SceneState) {
    // showBullets(state.items, true)
    setupItemInteractions(state)
    input.start()

    // setTimeout(() => showBullets(state.items, false), ANIMATION.BULLETS_HIDE_DELAY)
  }
}
